import type { SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * Select es un desplegable nativo estilizado a juego con Input (mismo alto táctil y
 * estados de foco/invalid). Nativo a propósito: accesible, sin dependencias y con el
 * selector del sistema en móvil. Reutilizable por los formularios de los maestros de
 * fábrica (#28–#31).
 */
export function Select({ className, ...props }: SelectProps) {
  return (
    <select
      className={cn(
        "flex h-12 w-full rounded-lg border border-slate-300 bg-white px-4 text-base text-slate-900 shadow-sm transition-colors focus-visible:border-primary-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-red-500 aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-red-500/30",
        className,
      )}
      {...props}
    />
  );
}
